import React, { Component } from 'react';
/*import { connect } from 'react-redux';*/
import { Link } from 'react-router-dom';
import IconIndicator from '../Helpers/IconIndicator.jsx';
import TagsStr from '../Helpers/Tags/TagsStr';
import Moment from 'react-moment';
import LazyImg from '../Helpers/LazyImg';
import Aspect from '../Helpers/Aspect';
import 'moment/locale/ru';
import { observer } from "mobx-react";

class BlogItem extends Component {
  isHavePreviewText() {
    const max=10;
    const min=0;
    const rand=Math.random() * (max - min) + min;

    if(rand<=5) {
      return false;
    } else {
      return true;
    }
  }
  isHaveAvatar() {
    return true;
    const max=10;
    const min=0;
    const rand=Math.random() * (max - min) + min;

    if(rand<=5) {
      return false;
    } else {
      return true;
    }
  }
  getStyle() {
    if(this.isHaveAvatar()) {
      return {
        background: `url(/autoresize/600x200xC${this.props.property_POST_AVATAR})`,
        backgroundSize: 'cover'
      }
    }
    return {}
  }
  render() {
    if(this.props.dummy) {
      return (
        <div className="cell mbottom20 bg-w3-op80 rad5 pr" style={{height:247}}>
        </div>
      );
    }
    const haveAvatar=this.isHaveAvatar();
    return (
      <div className="cell boxShadow solid1 bo-w2 mbottom20 bg-w1 pr">
        <div className="up12-v s-v-nowrap h100 splice">
          <div className="v-cell  s-v-auto" style={{height:'auto'}}>
            {haveAvatar && (
              <Aspect pa={true} aspect="1:3">
                <LazyImg src={`/autoresize/600x200xC${this.props.property_POST_AVATAR}`} className="db mw100" />
              </Aspect>
            )}
            <div className="s-padd5 m-padd10 bg-w1-op20">
              <div className="s-fs14 m-fs18 b1">
                {this.props.name}
              </div>

              {haveAvatar || (
                <div className="ptop10">
                  Доброго времени суток, полкадамы и полкагоспода! Мой первый блог будет посвящён небольшому обзору на Стар Платинума, станда из 3 части аниме и манги Jojo's Bizarre Adventure от Medicos Entertainment и их новой линейки Super Action Statue BIG...
                  Мой первый блог будет посвящён небольшому обзору на Стар Платинума, станда из 3 части аниме и манги Jojo's Bizarre Adventure от Medicos Entertainment и их новой линейки Super Action Statue BIG...
                </div>
              )}

              {this.props.tag && this.props.tag.length?(
                <div className="ptop10 s-fs12 m-fs14">
                  <TagsStr tags={this.props.tag} />
                </div>
              ):null}
              <div className="ptop10 s-fs12 m-fs14">
                <div className="up12 splice">
                  <div className="cell s-12 m-shrink">
                    @{this.props.user_nick}
                  </div>
                  <div className="cell s-12 m-auto only-s-ptop5 m-tar">
                    <Moment className="" locale="ru" format="ll">{this.props.created_time}</Moment>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="v-cell s-v-shrink">
            <div className="s-ptop5 m-ptop20 ">
              <IconIndicator className="s-pleft5 m-pleft10 op50" icon="thumb-up-outline" integer={this.props.rating_mark} />
              <IconIndicator className="s-pleft5 m-pleft10 op50" icon="eye">{this.props.view_unique?this.props.view_unique:0} / {this.props.view_all?this.props.view_all:0}</IconIndicator>
              <IconIndicator className="s-pleft5 m-pleft10 op50" icon="comment-outline">{this.props.c_comments_value?this.props.c_comments_value:0}</IconIndicator>
            </div>
          </div>
        </div>

        <Link className="clear b1 tdni pa pa-tl w100 h100" to={`/blog/${this.props.id}`}></Link>
      </div>
    )
  }
}


export default observer(BlogItem);